import angular from 'angular';

export default angular.module('Cartonomy.Cart', []);



// WEBPACK FOOTER //
// ./src/modules/cart/module.js